import React from 'react';

const HighlightedText = ({ text, mistakes }) => {
   // if(!mistakes.length) return <>{text}</>;

   // let parts = [];
    //let lastIndex = 0;

   //mistakes.forEach((mistake, idx) => {
       // const regex = new RegExp(`\\b${mistake}\\b`, "gi");
       // let match;
       // while ((match = regex.exec(text)) !== null) {
         //   if (match.index > lastIndex) {
          //     parts.push(text.substring(lastIndex, match.index));
          //  }
            //parts.push(<span key={`${idx}-${match.index}`} className="highlight">{match[0]}</span>);
           // lastIndex = regex.lastIndex;
       //}
   // });

   //if (lastIndex < text.length) {
    //    parts.push(text.substring(lastIndex));
   // }

   // return <>{parts}</>;
   
    if (!mistakes || mistakes.length === 0) {
        return <span>{text}</span>;
    }

    let highlightedText = text;
    mistakes.forEach((mistake) => {
        const regex = new RegExp(`\\b${mistake}\\b`, "gi");
        highlightedText = highlightedText.replace(regex, `<span class="highlight">${mistake}</span>`);
    });

    return <span dangerouslySetInnerHTML={{ __html: highlightedText }} />;
};

export default HighlightedText;

